const components = [];

import applicationSchoolSelector from './frontend/components/applicationSchoolSelector';
import applicationForm from './frontend/applicationForm';

components.push(new applicationSchoolSelector());
components.push(new applicationForm());

components.forEach(component => {
    if (component.init) {
        component.init();
    }
});
